// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"477":"592517e5","565":"5c045ebb","782":"8b9ba997"}[chunkId] + ".chunk.js";
};